<template>
  <div class="content">
    <el-row style="width: 94%;
    padding-top: 3%;
    margin-left: 3%;
    background-color: white;
    text-align: left;
    font-family: Calibri;
    padding-bottom:200px;">
      <el-col>
        <el-row style="padding-top: 15px;">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          In this study, we used daily maximum temperature as metric to calculate heatwave. The daily maximum temperature data was from NEX-GDDP dataset, which was released by NASA in June 2015 (https://dataserver.nccs.nasa.gov/thredds/catalog/bypass/NEX-GDDP/catalog.html). The spatial resolution of the dataset is 0.25° × 0.25°. There are 21 general circulation models in this dataset which contain two Representative Concentration Pathways (RCPs), RCP4.5 and RCP8.5, for the period from 2006 to 2100. The temperature data of lower emission scenario RCP2.6 was computed by sub-project 1. The population projection data used in this study contained SSP1-3 computed by sub-project 2. We calculated heatwave intensity and mortality risk for two periods 2016-2035 and 2046-2065 in future compared to 1986-2005 under three RCP-SSP combinations-namely, RCP2.6-SSP1, RCP4.5-SSP2, and RCP8.5-SSP3. Figures showed in this session are multi-model ensemble results.
        </el-row>
        <el-row style="text-align: center;">
          <img style="width: 80%;" src="http://bunjs.aiside.top/7-1.png"/>
          <br/>
          <span>Fig. 1 Technical flowchart for mapping global heatwave mortality risk</span>
        </el-row>

        <el-row class="r_title">Heatwave intensity metrics</el-row>
        <el-row class="r_content r_marginTop">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          To better estimate regional changes of heatwave mortality risk in the world, we chose a relative threshold instead of an absolute threshold. The heatwave here was defined as at least 3 consecutive days exceeding the given threshold where the threshold was the 95th percentile value of the daily maximum temperature series over the baseline period 1986-2005 at grid level, if the 95th percentile value was lower than 25℃,we set 25℃ as the threshold in this grid. The annual heatwave duration was defined as the total heatwave days in a given year. The annual heatwave maximum temperature was defined as the maximum temperature of all the heatwave events in a year.
        </el-row>


        <el-row class="r_title">Population vulnerability</el-row>
        <el-row class="r_content r_marginTop">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          In this study, totally six mortality vulnerability curves for typical cities in the world were adopted (Gosling, McGregor, & Páldy, 2007). In IPCC-SREX reports, the world is divided into 26 regions  (Seneviratne et al., 2012). We regrouped 26 regions into six groups according to climate types, latitude zones and terrain elevation. Each vulnerability curve was applied to each group of the IPCC-SREX regions to map heat wave mortality risk of the world.
        </el-row>


        <el-row class="r_title">Mortality risk function</el-row>
        <el-row class="r_content r_marginTop">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Heat wave mortality risk of the world is assessed with formula (1):
        </el-row>
        <el-row style="text-align: center;">
          <img style="margin-top: 20px;" src="http://bunjs.aiside.top/7-2.png"/>
          <br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Where R is the annual heat wave mortality risk; F represents the regional vulnerability function; Tmax refers to the annual maximum temperature during heatwave, P refers to the annual total population of each grid and D is the annual heat wave duration (days). We computed the annual heatwave mortality risk for the selected periods-namely, 1986-2005, 2016-2035 and 2046-2065. To map the spatial distribution, we then computed the 20-year average value for each period. All of the calculations, analyses and the figures of the meteorological metrics and heatwave mortality risk are performed at grid level (0.25°×0.25°).
        </el-row>

      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "GlobalGDPLossRiskToRiverFloods"
  }
</script>

<style scoped>

  .r_content{

  }
  .r_marginTop{
    margin-top: 15px;
  }

  .r_title{
    font-weight: bold;
    font-size: 2.5rem;
    margin-top: 30px;
  }



  .content{
    overflow-y: scroll;
    line-height: 40px;
    font-size: 2.2rem;
    color: black;
  }
  .content::-webkit-scrollbar {
    display: none;/*隐藏滚动条*/
  }
</style>



// WEBPACK FOOTER //
// src/view/BSD/About/GlobalGDPLossRiskToRiverFloods.vue